import { useState, type ReactNode } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/utils/utils";

export interface THomepageGroupSectionProps {
    label: string;
    /** Rendered at the right of the header row, directly above the columns. */
    headerRight?: ReactNode;
    children: ReactNode;
    defaultExpanded?: boolean;
    className?: string;
}

/**
 * Collapsible "⌄ SUBMISSION" wrapper around the board's three columns
 * (design doc §7.1, §7.3). Only one group exists today — this is the seam
 * the deferred Finance Team grouping ticket drops into, at no cost now.
 */
export function HomepageGroupSection({
    label,
    headerRight,
    children,
    defaultExpanded = true,
    className,
}: THomepageGroupSectionProps) {
    const [expanded, setExpanded] = useState(defaultExpanded);

    return (
        <div className={className}>
            <div className="mb-3 flex flex-wrap items-center justify-between gap-3">
                <button
                    type="button"
                    onClick={() => setExpanded((e) => !e)}
                    aria-expanded={expanded}
                    className="flex items-center gap-1.5 text-sm font-semibold uppercase tracking-wide text-muted-foreground hover:text-foreground"
                >
                    <ChevronDown
                        className={cn("h-4 w-4 transition-transform", !expanded && "-rotate-90")}
                    />
                    <span>{label}</span>
                </button>
                {headerRight}
            </div>
            {expanded && children}
        </div>
    );
}
